export default {
  loading: 'Cargando reclamaciones',
  section: 'Reclamaciones',
  headers: {
    date: 'Fecha de creación',
    folio: 'Folio',
    type: 'Tipo de reclamación',
    restaurant: 'Restaurante',
    status: 'Estatus',
    updated: 'Última actualización'
  }
}
